module.exports = __webpack_public_path__ + "img/猪苓.1308ea0b.jpg";